<template>
  <div >
    <v-navigation-drawer v-model="drawer_p" fixed temporary right width="40%" style="z-index:203">
      <v-list-item style="background-color:#A553BB" dark>
        <v-list-item-content>
          <v-list-item-title>CENTRAL DE AJUDA</v-list-item-title>
          
        </v-list-item-content>
       
      </v-list-item>

      <v-divider></v-divider>

      <div class="my-5 px-5">
        <template v-if="tag == 'product_name'">
          <h3>Nome do Produto</h3>
          <p>Aqui você digita o TÍTULO do seu SINGLE, EP ou ÁLBUM</p>
          <p>Se for um SINGLE, o campo "Nome do Produto" deve ser exatamente igual ao "Nome da Faixa".</p>
          <br><b style="color:red">IMPORTANTE!</b><br>
          <p>O "Nome do Produto"  e o nome do “Artista Principal “ precisam obrigatoriamente estar na foto da CAPA. Isso vale para EP e ÁLBUM também</p>
          <p>Esse campo é utilizado para diferenciar os seus produtos dos demais produtos nas plataformas digitais e facilitar que os seus fãs encontrem o seu conteúdo!</p>
          <p>Veja como o nome do produto aparecerá nas plataformas:</p>
          <p class="text-center">
            <img src="@/assets/help/product/EXEMPLO_NOME_DO_PRODUTO_PLATAFORMA.jpg" />
          </p>
        </template>

        <template v-if="tag == 'product_upc'">
          <h3>Código de Barras (UPC)</h3>
          <p>Abreviação de "Universal Product Code". É o Código de Barras que identifica seu produto. Ele é essencial na hora de gerar os relatórios e os pagamentos referentes às vendas do seu produto.</p>
          <p>Além disso, quando você gera o Código de Barras pela Nova Música Gospel você recebe um código válido internacionalmente.</p>
          <p>Esse mesmo código pode ser usado também para produtos físicos.</p>
          <p>Se você já tiver um Código de Barras gerado para esse seu produto, recomendamos que você o utilize. Dessa forma, o seu produto ficará sempre vinculado à um mesmo cadastro.</p>
          <p>Caso você não tenha podemos gerar um para você. Basta assinalar na resposta “Não, gostaria de adquirir um válido por R$ 39,99, e deixar o campo em branco. Após a confirmação do pagamento este espaço será preenchido automaticamente com um código de barras válido internacionalmente.</p>
        </template>

        <template v-if="tag == 'product_cover'">
          <h3>CAPA</h3>
          <p>O "Nome do Produto"  e o nome do "Artista Principal" precisam obrigatoriamente estar na foto da CAPA. Isso vale para  SINGLE, EP e ÁLBUM também.</p>
          <p>Lembre-se que se seu produto for um SINGLE, o campo "Nome do Produto" deve ser exatamente igual ao "Nome da Faixa".</p>
          <p>Essa é a imagem que representará o seu produto em todas as plataformas digitais. Então capriche nessa arte!  Ela poderá até ser usada para campanhas pelas plataformas também para promovê-lo.</p>
          <p>É obrigatório o envio de uma imagem quadrada de no minímo de 1500x1500 pixels, mas recomendamos 3000x3000 e no máximo 3MB (megabytes)</p>
          
          <p>Veja como a imagem do produto aparece nas plataformas. </p>
          <p class="text-center">
            <img src="@/assets/help/product/EXEMPLO_DE_CAPA.jpg" />
          </p>

        </template>

        

        <template v-if="tag == 'product_type'">
          <h3>Formato de Produto</h3>
          <p>Essa opção nos ajuda a entender melhor o seu produto e é um campo requisitado em alguma plataformas!</p>          
          <p>Entenda as opções</p>
          <h3>Single</h3>
          <p>
            Se seu produto tem apenas uma faixa, é um SINGLE.<br>
            <br><b style="color:red">IMPORTANTE!</b><br>
            - Para esse formato o campo "Nome do Produto"; deve ser exatamente igual ao "Nome da Faixa".<br>
            - O "Nome do Produto" e o nome do "Artista Principal" precisam obrigatoriamente estar na foto da CAPA.
          </p>
          <h3>EP </h3>
          <p>Se seu produto tem duas, três, quatro, cinco ou seis faixas é um EP.</p>
          <h3>Álbum </h3>
          <p>Se o seu produto tem mais de seis faixas e até 16 faixas é um ÁLBUM.</p>
        </template>

        <template v-if="tag == 'product_release'">
          <h3>Data de Lançamento</h3>
          <p>Esse é o grande dia! É quando seu SINGLE, EP ou ÁLBUM estará disponível para ser ouvido por todo mundo nas plataformas digitais.</p>
          <p>Recomendamos o mínimo de 15 dias a contar da data de aprovação do pagamento para o lançamento, e não nos responsabilizamos por prazos menores que o recomendado.</p>

          <p><strong>Entenda porque:</strong><br>
          Com uma data de lançamento antes deste prazo de 15  dias o seu produto corre risco de não estar liberado em todas as plataformas simultaneamente.
          Isso acontece porque cada plataforma tem um tempo diferente para processar e preparar o seu produto antes de disponibilizar na plataforma.<br></p>
          <p>Mantendo a nossa recomendação faremos de tudo para que o seu produto esteja em todas as plataformas ao mesmo tempo no dia estipulado!</p>
        </template>

        <template v-if="tag == 'product_copyright_year'">
          <h3>Ano de Copyright</h3>
          <p>Esse é o ano que seu SINGLE, EP ou ÁLBUM foi produzido e gravado.</p>
          <p>O <b>ano de copyright</b> aparecerá abaixo do botão de play nas plataformas digitais.</p>
          
          <p>
             <p class="text-center">
            <img src="@/assets/help/product/EXEMPLO_DE_COPYRIGHT_PLATAFORMA.jpg" />
          </p>
        </template>

        <template v-if="tag == 'product_copyright'">
          <h3>Copyright</h3>
          <p>Digite aqui o nome da pessoa ou empresa que detém os direitos para comercialização e distribuição do seu produto. Esse Copyright é o objeto do contrato que você assinou conosco licenciando à Nova Musica Gospel para distribuição do seu SINGLE, EP ou ÁLBUM nas plataformas digitais.</p>
        </template>

        <template v-if="tag == 'product_copyright_phonogram'">
          <h3>Copyright da Gravação</h3>
          <p>Digite aqui o nome da pessoa, empresa ou estúdio que detém os direitos financeiros da gravação do seu produto.</p>
        </template>

        <template v-if="tag == 'product_track_name'">
          <h3>Nome da Faixa</h3>
          <p>Aqui você digita o título da sua música, que deve ser o mesmo que aparece no campo obras da faixa.</p>
          <p>Esse título da cada música aparecerá em todas as plataformas digitais.</p>
        </template>

        <template v-if="tag == 'product_track_isrc'">
          <h3>ISRC</h3>
          <p>Abreviação de "International Standard Recording Code", ou Código de Gravação Padrão Internacional.</p>
          <p>É esse o código que identifica de forma única as gravações de qualquer tipo, ele representa o registro internacional tanto da obra quanto da faixa que juntas formam o áudio ou fonograma gravado.</p>
          <p>O Código de Barras identifica O PRODUTO (SINGLE, EP ou ÁLBUM)</p>
          <p>O ISRC identifica o FONOGRAMA (OBRA + FAIXA)</p>
        </template>

        <template v-if="tag == 'product_track_work'">
          <h3>Obras da Faixa</h3>
          <p>Aqui você “monta” a ordem das faixas do seu SINGLE, EP ou ÁLBUM com aquelas obras musicais que você cadastrou previamente.</p>
          <p>Por isso é importante começar pelo cadastro das obras, pois obras fazem faixas e faixas fazem SINGLES, EPs ou ÁLBUMS.</p>
          <p>As obras ficam vinculadas à faixa, por isso elas tem o mesmo nome. Então, lembre-se de cadastrar todas as obras que você tem direito de uso.</p>
          <p>IMPORTANTE: Se você gravou um medley (duas ou mais músicas juntas numa mesma faixa) selecione cada uma das obras que fazem parte desse medley, na ordem em que foram cantadas.</p>
        </template>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer_p: null,
      tag: null
    };
  },
  methods: {
    show(tag) {
      if (!tag) {
        return;
      }
      this.drawer_p = true;
      this.tag = tag;
    }
  }
};
</script>